import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { EmptyDictPrompt } from "./EmptyDictPrompt";

/**
 * WizardStep2 — Pick an ölçü grubu + multi-select which measures (Göğüs,
 * Bel, ...) belong in this table. Snapshot pattern: cloning the group's
 * measures decouples this table from future dictionary edits.
 */
export const WizardStep2 = ({ groups, groupId, onPickGroup, pickedMeasures, onToggleMeasure, onPickAll, onClearAll, selectedGroup }) => {
    if (groups.length === 0) {
        return <EmptyDictPrompt kind="group" />;
    }
    return (
        <div className="space-y-4" data-testid="wizard-step-2">
            <div>
                <div className="text-[11px] font-semibold tracking-wider uppercase text-muted-foreground mb-2">
                    Hangi gruptan ölçüleri seçeceksin?
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {groups.map((g) => (
                        <button
                            key={g.id}
                            onClick={() => onPickGroup(g.id)}
                            className={`text-left rounded-lg border p-3 transition-all ${groupId === g.id ? "border-foreground/40 bg-muted/40 ring-1 ring-foreground/10" : "border-border bg-surface hover:border-foreground/20"}`}
                            data-testid={`group-option-${g.id}`}
                        >
                            <div className="flex items-center justify-between gap-2">
                                <div className="min-w-0">
                                    <div className="font-display text-sm font-bold tracking-tight truncate">{g.name}</div>
                                    {g.scope && <div className="text-[10.5px] text-muted-foreground truncate">{g.scope}</div>}
                                </div>
                                <Badge variant="outline" className="text-[10px] font-mono shrink-0">{g.measures.length}</Badge>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {selectedGroup && (
                <div className="rounded-xl border border-border bg-surface" data-testid="measure-multiselect">
                    <div className="px-4 py-3 border-b border-border flex items-center justify-between gap-2">
                        <div>
                            <div className="text-[11px] font-semibold tracking-wider uppercase text-muted-foreground">
                                Bu tabloda hangi ölçüler olsun?
                            </div>
                            <div className="text-[10.5px] text-muted-foreground mt-0.5">
                                {selectedGroup.name} setinden ihtiyaç duyduklarını işaretle · <span className="text-foreground/70">{selectedGroup.name}&apos;ndaki sonraki güncellemeler bu tabloyu etkilemez</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-1 shrink-0">
                            <Button size="sm" variant="ghost" className="h-7 text-[11px]" onClick={onPickAll} data-testid="pick-all-measures">Tümünü Seç</Button>
                            <Button size="sm" variant="ghost" className="h-7 text-[11px] text-muted-foreground" onClick={onClearAll}>Temizle</Button>
                        </div>
                    </div>
                    <div className="p-3">
                        <div className="flex flex-wrap gap-1.5">
                            {selectedGroup.measures.map((m) => {
                                const active = pickedMeasures.includes(m.name);
                                return (
                                    <button
                                        key={m.name}
                                        onClick={() => onToggleMeasure(m.name)}
                                        className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-all border ${
                                            active
                                                ? "bg-foreground text-background border-foreground"
                                                : "bg-background text-foreground border-border hover:border-foreground/40"
                                        }`}
                                        data-testid={`measure-toggle-${m.name}`}
                                    >
                                        {active && <Check className="h-3 w-3" strokeWidth={3} />}
                                        {m.name}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="mt-3 text-[11px] text-muted-foreground">
                            <span className="font-medium text-foreground">{pickedMeasures.length}</span> ölçü seçildi · tablo {pickedMeasures.length} sütun olacak
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
